import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import NumberFormat from 'react-number-format';
import {EXPOSICION_MAXIMA_PERMITIDA} from '../CONST'
import isUserHasProfile from '../helpers/profileValidator';
import { EXPOSICION_MAXIMA_LIMITE_SUPERADO } from '../helpers/profilePermission';

class GeneralLineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.updateFileList = this.updateFileList.bind(this);
    this.checkBalance = this.checkBalance.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { documents } = this.props;
    if (prevProps.documents !== documents) {
      this.updateFileList();
    }
  }

  updateFileList() {
    const { documents } = this.props;
    this.setState({ fileList: documents });
  }

  handleDelete(file) {
    const { fileList } = this.state;
    const list = [...fileList];
    this.setState({
      fileList: list.filter(node => node !== file),
    });
  }

  checkBalance(value) {
    const { linea } = this.props;
    const { floatValue } = value;
    if (
      linea.nemotecnico === 'exposicion_maxima' &&
      !isUserHasProfile(EXPOSICION_MAXIMA_LIMITE_SUPERADO) &&
      linea.monto + floatValue > EXPOSICION_MAXIMA_PERMITIDA
    ) {
      return false;
    }
    return true;
  }

  render() {
    const {
      fileTable,
      aumento,
      handleLine,
      handleTextArea,
      justificacion,
      lineValue,
      nuevoMonto,
    } = this.props;
    return (
      <div>
        <Row>
          <Col className="form-block" sm={{ size: 4 }}>
            <div className="label">Monto UF</div>
            <div className="value">
              <NumberFormat
                allowNegative={false}
                isAllowed={this.checkBalance}
                className="form-control"
                decimalScale="2"
                fixedDecimalScale
                decimalSeparator=","
                id="deltaLinea"
                name="deltaLinea"
                onValueChange={handleLine}
                prefix={!aumento ? '-' : ''}
                thousandSeparator="."
                value={lineValue}
              />
            </div>
          </Col>
          <Col className="form-block" sm={{ size: 4, offset: 3 }}>
            <div className="label">Nuevo Monto</div>
            <div className="value">
              <p className="form-values" id="nuevoMonto">
                <NumberFormat
                  decimalScale="2"
                  fixedDecimalScale
                  decimalSeparator=","
                  displayType="text"
                  value={nuevoMonto}
                  thousandSeparator="."
                />
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="label">Justificación</div>
            <div className="textarea">
              <textarea
                className="form-control"
                id="justificacion"
                name="justificacion"
                onChange={handleTextArea}
                placeholder="Escribir justificación"
                rows="2"
                value={justificacion}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="label">Adjuntar Archivos</div>
            {fileTable}
          </Col>
        </Row>
      </div>
    );
  }
}

GeneralLineForm.propTypes = {
  aumento: PropTypes.bool.isRequired,
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  filesTable: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  handleLine: PropTypes.func.isRequired,
  handleTextArea: PropTypes.func.isRequired,
  justificacion: PropTypes.string.isRequired,
  linea: PropTypes.shape({
    label: PropTypes.string,
    monto: PropTypes.number,
    nemotecnico: PropTypes.string,
  }).isRequired,
  lineValue: PropTypes.number.isRequired,
  nuevoMonto: PropTypes.number.isRequired,
  fileTable: PropTypes.node.isRequired,
};

GeneralLineForm.defaultProps = {
  documents: [],
};

export default GeneralLineForm;
